import { useHistory } from 'react-router-dom';
import { useSignupWizard } from './signup-wizard-context';

interface StepNavigationOptions {
  currentStep: number;
  nextPath?: string;
  prevPath?: string;
  onBeforeNext?: () => Record<string, any>;
  validate?: () => boolean;
  eventName?: string;
}

export function useStepNavigation({ currentStep, nextPath, prevPath, onBeforeNext, validate, eventName }: StepNavigationOptions) {
  const history = useHistory();
  const { updateState, completeStep, setCurrentStep, trackEvent, withSource } = useSignupWizard();

  const handleNext = () => {
    if (validate && !validate()) return;
    if (onBeforeNext) {
      const data = onBeforeNext();
      updateState(data);
    }
    completeStep(currentStep);
    if (eventName) trackEvent(eventName);
    if (nextPath) {
      setCurrentStep(currentStep + 1);
      history.push(withSource(nextPath));
    }
  };

  const handleBack = () => {
    if (prevPath) history.push(withSource(prevPath));
  };

  return { handleNext, handleBack };
}
